<template>
  <header class="header">
    <div class="header__wrapper">
      <div class="header__row">
        <!-- лого -->
        <div class="header__logo">
          <router-link :to="{ name: 'RouterListDTPage' }" class="logo">
            <img
              src="@/assets/img/logo.svg"
              alt="Логотип"
              width="32"
              height="32"
            />
            <span class="header__txt">{{ titleName }}</span>
          </router-link>
        </div>

        <div class="menu-wrapper">
          <edStatuses />
          <span
            v-if="user"
            class="btn-header-menu"
            @click="showMenu = !showMenu"
          >
            Меню
            <img
              src="@/assets/img/icons/burger-menu.svg"
              alt=""
              width="16"
              height="14"
            />
          </span>
          <div
            class="nav-wrapper"
            :class="showMenu ? `nav-wrapper--open` : `nav-wrapper--close`"
          >
            <nav class="nav-left">
              <!-- Cписок ДТ -->
              <router-link
                :to="{ name: 'RouterListDTPage' }"
                v-if="user"
                class="nav-item nav-item-left"
                :class="
                  this.activePage === 'ListDTPage' ? 'nav-item-current' : ''
                "
              >
                Декларации в работе
              </router-link>
              <!-- Отчеты -->
              <router-link
                :to="{ name: 'RouterFrReportPage' }"
                v-if="user && user.reports_enabled"
                class="nav-item nav-item-left"
                :class="
                  this.activePage === 'FrReportPage' ? 'nav-item-current' : ''
                "
              >
                Отчеты
              </router-link>
            </nav>
            <!-- <edStatuses /> -->
            <nav class="nav-right">
              <download-excel
                v-if="user && user.excel_enabled && excelBtn.show"
                :data="excelBtn.getData()"
                :fields="excelBtn.json_fields"
                :meta="excelBtn.json_meta"
                :worksheet="excelBtn.worksheet"
                :name="excelBtn.file_name"
                class="nav-item nav-item-right nav-item-excel"
              >
                <span class="btn-menu btn-menu-excel"> В Excel </span>
                <img
                  class="btn-img"
                  src="@/assets/img/icons/download.svg"
                  alt=""
                  width="20"
                  height="20"
                />
              </download-excel>
              <router-link
                v-if="user && user.options_enabled"
                class="nav-item nav-item-right nav-item-options"
                :to="{ name: 'OptionsPage' }"
                :class="
                  this.activePage === 'OptionsPage' ? 'nav-item-current' : ''
                "
              >
                <span class="btn-menu">Настройки</span>
                <img
                  class="btn-img"
                  src="@/assets/img/icons/settings.svg"
                  alt=""
                  width="20"
                  height="20"
                />
              </router-link>
              <a
                v-if="user"
                key="logout-link"
                href="javascript:void(0)"
                class="nav-item nav-item-right"
                @click="$logout"
              >
                <span class="btn-menu">Выйти</span>
                <img
                  class="btn-img"
                  src="@/assets/img/icons/logout.svg"
                  alt=""
                  width="20"
                  height="20"
                />
              </a>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import JsonExcel from "vue-json-excel3";
import EdStatuses from "@/components/EdStatuses";

import { logout } from "@/common/mixins";
let titleName = "Монитор ВЭД";
export default {
  name: "HeaderComponent",
  props: {
    activePage: {
      type: String,
      default: "ListDTPage",
    },
    excelBtn: {
      type: Object,
      default: () => ({
        show: false,
        json_fields: {},
        json_meta: [],
        data: [],
        worksheet: "Лист 1",
        file_name: "default.xslx",
      }),
    },
  },
  data() {
    return {
      titleName,
      showMenu: false,
    };
  },
  mixins: [logout],
  components: {
    downloadExcel: JsonExcel,
    edStatuses: EdStatuses,
  },
  computed: {
    ...mapState("Auth", ["user"]),
  },
};
</script>
